import React from "react";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import Modal from "react-native-modal";
import {
  MainTitle,
  Box,
  MainText,
  MainButton,
  PressableOpacity,
} from "app/components/common";
import achievementBadges from "../../scenes/UserProfile/Badges/achievementBadges";
import Stars from "./Stars";
import normalize from "app/utils/normalize";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import mbtiJouvieGroup from "../../../assets/images/mbtiJouvieGroup.png";
import { Image, Linking, Pressable } from "react-native";
import theme from "app/Theme/Theme";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import FastImage from "react-native-fast-image";

const MAX_WIDTH = isWebDesktop ? 400 : null;
const mbtiTestLinkFr =
  "https://www.16personalities.com/fr/test-de-personnalite";
const mbtiTestLinkEn = "https://www.16personalities.com/free-personality-test";
interface Props {
  isVisible?: boolean;
  onClose: () => void;
}

const ModalContent = ({ onClose }) => {
  const navigation = useNavigation();
  const language = useSelector(getLanguage);

  const goToMbtiSelection = () => {
    onClose();
    navigation.navigate("Mbti");
  };

  const openMbti = () => {
    if (language === "fr") {
      Linking.openURL(mbtiTestLinkFr);
    } else {
      Linking.openURL(mbtiTestLinkEn);
    }
    goToMbtiSelection();
  };

  return (
    <>
      <MainText
        marginBottom="sm"
        variant={isWebDesktop ? "l6-bold" : "l5-bold"}
      >
        {i18n.t("discover-your-mbti-profile")}
      </MainText>
      <MainText marginBottom="xs" variant="l3-bold">
        {i18n.t("what-is-this-?")}
      </MainText>
      <MainText marginBottom="sm" variant="l3-medium" color="neutral.600">
        {i18n.t("mbti-explanation")}
      </MainText>
      <MainText marginBottom="xs" variant="l3-bold">
        {i18n.t("what-the-point-?")}
      </MainText>
      <MainText marginBottom="l" variant="l3-medium" color="neutral.600">
        {i18n.t("mbti-explanation-2")}
      </MainText>
      <Box alignItems="center">
        <PressableOpacity
          style={{ marginBottom: theme.spacing.sm }}
          onPress={openMbti}
        >
          <MainText variant="l5-medium" color="brand.500">
            {i18n.t("I-already-know-my-profile")}
          </MainText>
        </PressableOpacity>
        <MainButton
          textVariant="l5-bold"
          color="brand.500"
          text={i18n.t("select-my-profile")}
          onPress={goToMbtiSelection}
          margin="null"
        />
      </Box>
    </>
  );
};

const ModalMobile = ({ onClose }) => {
  return (
    <Box
      maxWidth={MAX_WIDTH}
      alignSelf="center"
      backgroundColor="neutral.white"
      borderRadius={normalize(8)}
      padding="m"
      paddingVertical="sm"
    >
      <FastImage
        source={mbtiJouvieGroup}
        style={{
          width: normalize(225),
          height: normalize(150),
          alignSelf: "center",
          marginBottom: theme.spacing.xs,
        }}
        resizeMode="contain"
      />
      <ModalContent onClose={onClose} />
    </Box>
  );
};

const ModalDesktop = ({ onClose }) => {
  return (
    <Box
      backgroundColor="transparent"
      borderRadius={normalize(8)}
      padding="l"
      paddingVertical="sm"
      flexDirection="row"
    >
      <Box>
        <div
          style={{
            display: "flex",
            backgroundColor: theme.colors["neutral.white"],
            width: 500,
            borderRadius: 8,
            clipPath: "polygon(0 0, 80% 0%, 100% 100%, 0% 100%)",
            justifyContent: "flex-start",
          }}
        >
          <Box padding="l" paddingVertical="sm" width={268}>
            <ModalContent onClose={onClose} />
          </Box>
        </div>
        <FastImage
          source={mbtiJouvieGroup}
          style={{
            position: "absolute",
            width: normalize(404),
            height: normalize(364),
            marginBottom: theme.spacing.xs,
            marginLeft: normalize(270),
          }}
          resizeMode="contain"
        />
      </Box>
      <div
        style={{
          display: "flex",
          width: 500,
          height: 280,
          backgroundColor: theme.colors["brand.500"],
          zIndex: -1,
          position: "absolute",
          marginLeft: normalize(200),
          alignSelf: "flex-end",
          borderRadius: 8,
        }}
      />
    </Box>
  );
};

export const MbtiModal = ({ isVisible = false, onClose }: Props) => {
  return (
    <Modal
      onBackdropPress={onClose}
      animationInTiming={250}
      backdropTransitionOutTiming={0}
      animationOutTiming={200}
      isVisible={isVisible}
      hideModalContentWhileAnimating
      avoidKeyboard
      useNativeDriver
      backdropColor={theme.colors["neutral.800"]}
      style={{
        alignSelf: "center",
      }}
    >
      <Box style={{ marginRight: isWebDesktop ? normalize(200) : 0 }}>
        {isWebDesktop ? (
          <ModalDesktop onClose={onClose} />
        ) : (
          <ModalMobile onClose={onClose} />
        )}
      </Box>
    </Modal>
  );
};
